module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-02.f7d25dd0.jpg";